/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetOperationChangeHistoryDocument = gql`
    query GetOperationChangeHistory($companyId: Int!, $branchId: Int, $operationId: Int) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      branches(id: $branchId) {
        storageProductRelationHistoryPaginated(id: $operationId) {
          entities {
            id
            product {
              id
              name
            }
            operationNumber
            unit {
              id
              name
            }
            date
            action
            historyAction
            edited
            price
            cost
            operationHistories {
              id
              changeTime
              exists
              employee {
                id
                name
                surname
              }
              storageProductOperationHistoryData {
                id
                field
                value
                storage {
                  name
                }
                employee {
                  name
                  surname
                }
                client {
                  name
                  phone
                  email
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetOperationChangeHistoryQuery__
 *
 * To run a query within a React component, call `useGetOperationChangeHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOperationChangeHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOperationChangeHistoryQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      operationId: // value for 'operationId'
 *   },
 * });
 */
export function useGetOperationChangeHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetOperationChangeHistoryQuery, GetOperationChangeHistoryQueryVariables> & ({ variables: GetOperationChangeHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOperationChangeHistoryQuery, GetOperationChangeHistoryQueryVariables>(GetOperationChangeHistoryDocument, options);
      }
export function useGetOperationChangeHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOperationChangeHistoryQuery, GetOperationChangeHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOperationChangeHistoryQuery, GetOperationChangeHistoryQueryVariables>(GetOperationChangeHistoryDocument, options);
        }
export function useGetOperationChangeHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOperationChangeHistoryQuery, GetOperationChangeHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOperationChangeHistoryQuery, GetOperationChangeHistoryQueryVariables>(GetOperationChangeHistoryDocument, options);
        }
export type GetOperationChangeHistoryQueryHookResult = ReturnType<typeof useGetOperationChangeHistoryQuery>;
export type GetOperationChangeHistoryLazyQueryHookResult = ReturnType<typeof useGetOperationChangeHistoryLazyQuery>;
export type GetOperationChangeHistorySuspenseQueryHookResult = ReturnType<typeof useGetOperationChangeHistorySuspenseQuery>;
export type GetOperationChangeHistoryQueryResult = Apollo.QueryResult<GetOperationChangeHistoryQuery, GetOperationChangeHistoryQueryVariables>;
export type GetOperationChangeHistoryQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  operationId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetOperationChangeHistoryQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', branches?: Array<{ __typename?: 'BranchProxy', storageProductRelationHistoryPaginated?: { __typename?: 'StorageProductRelationHistoryPaginatedType', entities?: Array<{ __typename?: 'StorageProductRelationHistoryProxy', id: number, operationNumber?: any | null, date?: string | null, action?: Types.StorageProductRelationHistoryAction | null, historyAction?: Types.StorageProductRelationHistoryAction | null, edited: boolean, price: string, cost: string, product?: { __typename?: 'ProductProxy', id: number, name: string } | null, unit?: { __typename?: 'UnitProxy', id: number, name: string } | null, operationHistories?: Array<{ __typename?: 'StorageProductOperationHistoryProxy', id: number, changeTime?: string | null, exists: boolean, employee?: { __typename?: 'EmployeeProxy', id: number, name?: string | null, surname?: string | null } | null, storageProductOperationHistoryData?: Array<{ __typename?: 'StorageProductOperationHistoryDataProxy', id: number, field?: string | null, value?: string | null, storage?: { __typename?: 'StorageProxy', name: string } | null, employee?: { __typename?: 'EmployeeProxy', name?: string | null, surname?: string | null } | null, client?: { __typename?: 'ClientProxy', name?: string | null, phone?: string | null, email?: string | null } | null }> | null }> | null }> | null } | null }> | null } | null } | null };
